<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBuildingBlockStore } from '@/stores/buildingBlock'
import BuildingBlockCard from '@/components/building-block-form/BuildingBlockCard.vue'
import type { BlockSwitchIssueMap } from '@/components/building-block-form/utils/switchValidation'

const props = defineProps<{
  calculationId?: number | null
  readonly?: boolean
  switchValidationByBlock?: BlockSwitchIssueMap
}>()

const buildingBlockStore = useBuildingBlockStore()

const { items: buildingBlockItems } = storeToRefs(buildingBlockStore)

const visibleBuildingBlocks = computed(() =>
  buildingBlockItems.value.filter((block) => {
    const matchesCalculation = props.calculationId
      ? block.calculation === props.calculationId
      : true
    return !block.hidden && matchesCalculation
  })
)
</script>

<template>
  <div>
    <v-expansion-panels v-for="block in visibleBuildingBlocks" :key="block.id" class="mb-4">
      <BuildingBlockCard
        :block="block"
        :readonly="props.readonly"
        :switch-validation-issue="props.switchValidationByBlock?.[block.id]"
      />
    </v-expansion-panels>
  </div>
</template>
